import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Image, Platform } from 'react-native';
import React from 'react';
var RELOAD_COUNT_MAX = 3; // 图片默认最大重试次数
// declare const global: any;

var isIOS = Platform.OS === 'ios';

var QImage = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(QImage, _React$PureComponent);

  var _super = _createSuper(QImage);

  _createClass(QImage, null, [{
    key: "getSize",
    value: function getSize(uri) {
      var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var failure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      Image.getSize(uri, success, failure);
    }
  }]);

  // 图片加载最大重试次数
  function QImage(props) {
    var _this;

    _classCallCheck(this, QImage);

    _this = _super.call(this, props); // this.props = props;

    _defineProperty(_assertThisInitialized(_this), "state", void 0);

    _defineProperty(_assertThisInitialized(_this), "reloadCountMax", RELOAD_COUNT_MAX);

    _defineProperty(_assertThisInitialized(_this), "onLoadQAV", function (event, source) {
      var _this$props;

      if (_this.state.reloadCount > 0) {// logEvent(
        //     new QavEvent({
        //         action: 'image_retry_success',
        //         attributes: { source }
        //     })
        // );
      }

      (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onLoad(event);
    });

    if (props.reloadCountMax && props.reloadCountMax >= 0) {
      _this.reloadCountMax = props.reloadCountMax;
    }

    _this.state = {
      // 加载图片重试次数
      reloadCount: 0
    };
    return _this;
  }

  _createClass(QImage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = this.props || {},
          _ref$source = _ref.source,
          source = _ref$source === void 0 ? {} : _ref$source;

      if (source && source.uri && this.state.reloadCount > 0) {
        var uri = source.uri + (source.uri.indexOf('?') > -1 ? "&reloadCount=".concat(this.state.reloadCount) : "?reloadCount=".concat(this.state.reloadCount));
        source = _objectSpread(_objectSpread({}, source), {}, {
          uri: uri
        });
      }

      return <Image {...this.props} source={source} onLoad={function (event) {
        return _this2.onLoadQAV(event, source);
      }} onError={function (error) {
        var _this2$props;

        var nativeEvent = error ? error.nativeEvent : {};

        if (_this2.state.reloadCount < _this2.reloadCountMax) {
          var reloadCount = _this2.state.reloadCount + 1;

          _this2.setState({
            reloadCount: reloadCount
          });
        } else if (_this2.state.reloadCount === RELOAD_COUNT_MAX) {// logEvent(
          //     new QavEvent({
          //         action: 'image_load_failed',
          //         // page,
          //         attributes: {
          //             nativeEvent,
          //             source,
          //             timeStamp: Date.now()
          //         }
          //     })
          // );
        }

        (_this2$props = _this2.props) === null || _this2$props === void 0 ? void 0 : _this2$props.onError(error);
      }} />;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextSurce = nextProps && nextProps.source;
      var curtSurce = this.props && this.props.source;

      if (nextSurce.uri !== curtSurce.uri) {
        this.setState({
          // 重置加载图片重试次数
          reloadCount: 0
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.reloadCountMax = 0; // componentDidUnmount了，组建就销毁了，就把最大重试次数设置为0，就不重试了
    }
  }]);

  return QImage;
}(React.PureComponent);

export { QImage as default };